import { memo } from "react"
import { useUser } from "@tm/context-distribution"
import { SystemType } from "@tm/models"
import { CompleteProfileDialog } from "../user-settings/components/CompleteProfileDialog"
import { EditProfileModal } from "../user-settings/components/EditProfileModal"
import { UserSettingsDialog } from "./components/UserSettingsDialog"
import { CheckUserCredentialsSet } from "./components/CheckUserCredentialsSet"

export const SettingDialogs = memo(() => {
    const { userContext } = useUser()

    if (userContext.system.systemType !== SystemType.Next) {
        return null
    }

    return (
        <>
            <UserSettingsDialog />
            <EditProfileModal
                username={userContext.account?.username ?? ""}
                initialName={userContext.generalContact?.name ?? ""}
                initialEmail={userContext.generalContact?.email ?? ""}
            />
            <CompleteProfileDialog />
            <CheckUserCredentialsSet />
        </>
    )
})
